import { forwardRef } from 'react';
import type { SurveyCustomAction } from 'autogen/swagger/all';
import { useOpenSurveyQuickView } from 'components/surveySystem/shared/hooks/useOpenSurveyQuickView';
import { CustomActionButton } from '../shared/styles';
import type { CustomActionProps } from '../shared/types';

type SurveyActionProps = { action: SurveyCustomAction } & CustomActionProps;

const SurveyAction = forwardRef<HTMLButtonElement, SurveyActionProps>(({ action, onClick, ...restProps }, ref) => {
    const { openSurveyQuickViewBySurveyId } = useOpenSurveyQuickView();

    return (
        <CustomActionButton
            ref={ref}
            type="button"
            onClick={(e) => {
                if (onClick) {
                    onClick(e);
                }
                openSurveyQuickViewBySurveyId({ surveyId: action.surveyId, returnUrl: window.location.href });
            }}
            {...restProps}
        />
    );
});

export default SurveyAction;
